import React, {lazy,Suspense} from 'react';
import {localize} from '../i18n/runtime';

export const lazyNamed=(load,name='default')=>lazy(()=>load().then(module=>({default:module[name]})));

export function DeferredArea({children}) {
  return <Suspense fallback={<div role="status" className="px-6 py-16 text-center text-pt-tdim" data-testid="area-loading">{localize('ui.4959bc37c4c52ad5','Loading')} …</div>}>
    {children}
  </Suspense>;
}
